import React from "react";
var __jsx = React.createElement;
import { useState } from 'react';
import { Cell, Container, GridInfo, Row } from './TableGrid.style';
var gridSize = 5;
var grid = Array(gridSize).fill(Array(gridSize).fill(1));

var TableGrid = function TableGrid(_ref) {
  var insertTable = _ref.insertTable;

  var _useState = useState({
    cols: 0,
    rows: 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var handleHover = function handleHover(i, j) {
    setSize({
      cols: j + 1,
      rows: i + 1
    });
  };

  var handleClick = function handleClick() {
    insertTable({
      size: size
    })();
  };

  return __jsx(Container, null, grid.map(function (row, i) {
    return __jsx(Row, {
      key: "row-".concat(i)
    }, row.map(function (cell, j) {
      var isSelected = i <= size.rows - 1 && j <= size.cols - 1;
      return __jsx(Cell, {
        key: "cell-".concat(i, "-").concat(j),
        isSelected: isSelected,
        onMouseEnter: function onMouseEnter() {
          return handleHover(i, j);
        },
        onClick: handleClick
      });
    }));
  }), __jsx(GridInfo, null, size.cols, "x", size.rows));
};

export default TableGrid;